module.exports = __webpack_public_path__ + "img/icon_group@3x.3bd14ebd.png";